"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalPage = void 0;
var PortalPage;
(function (PortalPage) {
    PortalPage["ACCOUNTS"] = "ACCOUNTS";
    PortalPage["BENEFICIARIES"] = "BENEFICIARIES";
    PortalPage["HEDGING_SUMMARY"] = "HEDGING_SUMMARY";
    PortalPage["MARKET_ORDERS"] = "MARKET_ORDERS";
    PortalPage["STATEMENTS"] = "STATEMENTS";
    PortalPage["TRANSACTIONS"] = "TRANSACTIONS";
    PortalPage["SUPPORT"] = "SUPPORT";
    PortalPage["USER_GUIDES"] = "USER_GUIDES";
    PortalPage["MARKET_INFORMATION"] = "MARKET_INFORMATION";
    PortalPage["HEDGING_PROGRAMS"] = "HEDGING_PROGRAMS";
})(PortalPage = exports.PortalPage || (exports.PortalPage = {}));
